jQuery(document).ready(function ($) {
	var windowWidth = $(window).width();

	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (
			links[i].hostname !== window.location.hostname &&
			!links[i].classList.contains('account-link')
		) {
			links[i].target = '_blank';
		}
	}

	/******************************************
    Header Search
  ******************************************/

	// Show desktop search on click and focus on input
	$('.icon--search').on('click', function (e) {
		e.preventDefault();

		$('.desktop-search').fadeIn('fast', '', function () {
			$('body').addClass('search-open');
			$('.desktop-search input').focus();
		});
	});

	// Close desktop search if click outside
	$('body').on('click', function (e) {
		var desktopSearch = $('.desktop-search');

		if (
			!desktopSearch.is(e.target) &&
			desktopSearch.has(e.target).length === 0 &&
			$('body').hasClass('search-open')
		) {
			desktopSearch.fadeOut('fast', '', function () {
				$('body').removeClass('search-open');
				$('.icon--search').focus();
				$('#boost-sd__search-widget-init-wrapper').addClass(
					'boost-sd__g-hide'
				);
			});
		}
	});

	$('.header__icons .icon--search').on('click', function () {
		if (windowWidth > 992) {
			$('.fixed-wrap').css('transform', 'none').removeClass('scrolling');
		} else {
			$('.header__search').addClass('slid');
			$('.header__search').slideDown();
		}

		$('.header__search input').focus();
	});

	/******************************************
    Mobile Menu
  ******************************************/

	// Trigger mobile menu display
	$('.icon--mobile button').on('click', function () {
		if (!$('.fixed-wrap').hasClass('scrolling')) {
			var headerHeight = $('.fixed-wrap').innerHeight();
		} else {
			var headerHeight =
				$('.fixed-wrap').innerHeight() - $('.alert-bar').height();
		}
		$(this).toggleClass('is-active');
		$('html').toggleClass('mobile-menu-open');

		$('.mobile-menu').fadeToggle(170);
		//$('.mobile-menu').css('height', 'calc(100vh - ' + headerHeight + 'px)');
	});

	// // Panel Navigation
	// // Hide / Show panels on mobile menu
	// $('.mobile-menu .top-level.has-children a').on('click', function (e) {
	// 	e.preventDefault();
	// 	var dataTitle = $(this).attr('data-title');
	// 	$('.mobile-menu__front').fadeOut(170, function () {
	// 		$('.mobile-menu__back[data-title="' + dataTitle + '"]').fadeIn(170);
	// 	});
	// });

	// $('.mobile-menu .sub__heading .back').on('click', function () {
	// 	$('.mobile-menu__back').fadeOut(170, function () {
	// 		setTimeout(function () {
	// 			$('.mobile-menu__front').fadeIn(220);
	// 		}, 150);
	// 	});
	// });
	/******************************************
   Quick Buy Modal
  ******************************************/
	$('body').on('click', '.card--product .btn--quick-buy', function () {
		var productHandle = $(this).attr('data-handle');
		var modalID = $(this).attr('data-id');
		var noVars = false;

		$(this).find('.loader').css('opacity', 1);
		$(this).attr('disabled', 'disabled');

		if ($(this).hasClass('no-variants')) {
			noVars = true;
		}
		fetch(
			window.Shopify.routes.root +
				'products/' +
				productHandle +
				'?view=data'
		)
			.then((response) => response.text())
			.then((html) => {
				quickBuyData(html, modalID, noVars);
				$(this).find('.loader').css('opacity', 0);
				$(this).prop('disabled', '');
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	$('body').on('click', '.boost-sd-layout .btn--quick-buy', function (e) {
		e.preventDefault();
		var productHandle = $(this).attr('data-handle');
		var noVars = false;

		fetch(
			window.Shopify.routes.root +
				'products/' +
				productHandle +
				'?view=data'
		)
			.then((response) => response.text())
			.then((html) => {
				quickBuyData(html, 'quick-view_collection', noVars);
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});
	/******************************************
   Product Card Swatch Images
  ******************************************/
	$('.card__swatches .swatch').on('mouseenter', function () {
		var $this = $(this);
		var dataImage = $this.attr('data-image');
		var dataImageSrcset = $this.attr('data-image-srcset');
		var dataColor = $this.attr('data-color');
		// console.log(dataImage);
		if (dataImage.indexOf('no-image') === -1) {
			var newImage =
				'<img src="' +
				dataImage +
				'" srcset="' +
				dataImageSrcset +
				'" class="image--swatch image" style="display:none;" data-color="' +
				dataColor +
				'"/>';

			$this.closest('.card').find('.card__image a').append(newImage);
			$this.closest('.card').find('.image--swatch').show();

			$this
				.closest('.card')
				.find('.swatch')
				.removeClass('swatch--active');

			$this.addClass('swatch--active');
		}
	});

	$('.card__swatches .swatch').on('mouseleave', function () {
		$(this).closest('.card').find('.image--swatch').hide();

		$(this).closest('.card').find('.image--swatch').remove();

		$(this).removeClass('swatch--active');
	});

	/******************************************
    Modals
  ******************************************/

	// Launch the modal
	$('body').on('click', '.btn--modal', function (e) {
		e.preventDefault();
		var modalID = '#' + $(this).attr('data-modal');
		// console.log(modalID);

		if ($(this)[0].hasAttribute('data-video-yt')) {
			var videoID = $(this).attr('data-video-yt');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' +
						videoID +
						'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
				);
		}

		if ($(this)[0].hasAttribute('data-video-vimeo')) {
			var videoID = $(this).attr('data-video-vimeo');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' +
						videoID +
						'"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>'
				);
		}

		if ($(this)[0].hasAttribute('data-video')) {
			var videoID = $(this).attr('data-video');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><video playsinline="playsinline" autoplay="autoplay" loop="loop" controls class="video-panel__bg" preload="metadata"><source src="' +
						videoID +
						'" type="video/mp4"></video></div>'
				);
		}

		if ($(this)[0].hasAttribute('data-catalog')) {
			var catalogHtml = $(this).attr('data-catalog');
			$(modalID).find('.modal__inner').append(catalogHtml);
		}

		$(modalID).fadeIn('fast');
	});

	// Close the modal
	$('body').on('click', '.modal--close, .modal__bg', function (e) {
		closeModal($(this));
	});

	$('.modal--transplant button').on('click', function () {
		setCookie('transCookie', 'clicked');
		closeModal($('.modal--transplant'));
	});

	$('.modal--product-type button').on('click', function () {
		closeModal($('.modal--product-type'));
	});
	/******************************************
  Quick View Modal from Product Card ( Process ATC / Variant Options Select )
  ******************************************/

	$('body').on('change', '.modal--quick .option__wrap select', function () {
		quickViewVariant();
	});

	$('body').on('click', '.modal--quick .option__wrap button', function () {
		quickViewVariant();
	});

	/******************************************
  Quick View Modal Add to Cart
  ******************************************/
});

function closeModal(object) {
	object.closest('.modal').fadeOut('fast', function () {
		$('.modal__inner .iframe-wrap').remove();
		$('.modal--quick .modal__inner').empty();
		$('.modal--video .modal__inner').empty();
		$('.modal--catalog .modal__inner').empty();
	});
}
